export const platelistModelMixin = {
  data() {
    return {
      buildPlatelistModel(user) {
        return {
          applyCount: 0,
          archived: false,
          dateCreated: '',
          daysInPlatelist: '0',
          daysWithMeals: 0,
          description: '',
          dietData: [],
          draft: true,
          featuredImageUrl: '',
          id: 99999999,
          imageUrl:
            'https://res.cloudinary.com/menud/image/upload/v1568310432/Select_Plan_pmmuzt.jpg',
          influencerData: null,
          isFeatured: false,
          landingPageDescription: '',
          landingPageTitle: '',
          lastModified: '',
          maxDateWithMeal: null,
          mealsInPlatelist: 0,
          mobileHeroImageUrl: '',
          platelistImage:
            'https://res.cloudinary.com/menud/image/upload/v1568310432/Select_Plan_pmmuzt.jpg',
          type: 'Challenge',
          profileId: user.org.nutrition
            ? user.org.nutrition.platelistReferrerId
            : '',
          sharelink: '',
          tagData: [],
          title: '',
          payload: {
            admin: 'true',
            daysInPlan: 0,
            description: '',
            diets: [],
            featuredImageUrl: '',
            imageUrl:
              'https://res.cloudinary.com/menud/image/upload/v1568310432/Select_Plan_pmmuzt.jpg',
            isFeatured: false,
            landingPageDescription: '',
            landingPageTitle: '',
            linkSlug:
              Math.random()
                .toString(36)
                .substring(2, 15) +
              Math.random()
                .toString(36)
                .substring(2, 15),
            mobileHeroImageUrl: '',
            profileId: user.org.nutrition
              ? user.org.nutrition.platelistReferrerId
              : '',
            referrerName: user.roles.isAdmin
              ? user.org.name
              : `${user.trainer.firstName} ${user.trainer.lastName}`,
            roleModels: [],
            categories: [],
            shareImageUrl:
              'https://res.cloudinary.com/menud/image/upload/v1568310432/Select_Plan_pmmuzt.jpg',
            tags: [],
            title: '',
            type: 'Challenge',
          },
        };
      },
    };
  },
  methods: {
    $_getPlatelistModel() {
      if (this.currentUser) {
        return this.buildPlatelistModel(this.currentUser);
      }
    },
  },
};
